// extracted by mini-css-extract-plugin
export default {"container":"ComponentLoader_container__nQyq8"};